import { AxiosError, AxiosResponse, AxiosRequestConfig } from 'axios';
import { User } from './api/';
import { handleError } from '@utils/misc';

export interface UserT {}

interface UserParamsT {}

export interface ResponseT {
  errors: Array<string>;
  data: Array<any>;
}

const debug : boolean = false;
const useUserInfo = () => {

  const getUserInfo = async (token, params: UserParamsT): Promise<ResponseT> => {

    const config: AxiosRequestConfig = { params };
    let resp: ResponseT | null;

    await User.get(token, config)
      .then((response: AxiosResponse) => {
        if (debug) console.log('User.get AxiosResponse ', response);
        resp = response.data;
      })
      .catch((err: AxiosError) => {
        handleError(err);
        resp = null;
      });
    return resp;
  };

  return {
    getUserInfo,
  };
};
export default useUserInfo;
